import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { GlobalStyle as RapydGlobalStyle } from '@rapyd/react-ui-library';
import i18n from 'services/i18n';
import store from 'redux/store';
import CustomTheme from 'components/containers/Theme/Theme';
import App from 'App';
import 'uiAssets';
import GlobalStyle from 'GlobalStyle';

const V2Entry = () => {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <CustomTheme>
          <RapydGlobalStyle />
          <GlobalStyle />
          <App />
        </CustomTheme>
      </I18nextProvider>
    </Provider>
  );
};

export default V2Entry;
